module.exports = __webpack_public_path__ + "img/D201701_4.73b9b1d0.jpg";